import { APISERVICE } from "@util/apiService/RestClient";
import { resolveStoreId } from "@storeData/store";
import { withRetry } from "@util/apiError";
import { readLocalStorage, writeLocalStorage } from "@util/safeStorage";

export const getCurrentReleaseVersion = () => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_BASE_PCS_URL}/buildVersions?project=dashboard`)
            .then((response) => {
                res(response.data);
            }).catch(function (error) {
                rej(error);
            });
    })
}

/**
 * Bill rendering is the last step before the customer sees their invoice, and the endpoint returns
 * 5xx intermittently when it is hit alongside the rest of the page load. Retrying keeps a transient
 * blip from turning into a dead end on a link the customer can only open once.
 */
export const getBillPrintByOrder = (order: any, languageCode: string = 'en', combinePrintBill = false, headers: any = {}) => {
    return withRetry(() =>
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_PCS_TXN}/printBill?languageCode=${languageCode}&combinePrintBill=${combinePrintBill}&catalougeBill=${true}`, order, headers)
    ).then((response) => response.data);
}

export const getLanguages = (tenantId: any, storeId: any) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_BASE_PCS_URL}/languageMappings/tenantId/storeId?tenantId=${tenantId}&storeId=${storeId}`)
            .then((response) => {
                // console.log("response?.data?.data", response?.data?.data)
                res(Boolean(response?.data?.data?.length) ? response?.data?.data : [{ "languageId": "en", "displayName": "English" }]);
            }).catch(function (error) {
                console.error(error)
                rej(error);
            });
    })
}


export const getDisposableItemsList = (tenantId: any, storeId: any) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_GET_BASE_CATALOG_URL}/disposableItems?tenantId=${tenantId}&storeId=${storeId}`)
            .then((response) => {
                // console.log("response?.data?.data", response?.data?.data)
                res(Boolean(response?.data?.data?.length) && response?.data?.data);
            }).catch(function (error) {
                console.error(error)
                rej(error);
            });
    })
}

export const getBillingData = (tenantId: any, storeId: any, storeName: string = '') => {
    return new Promise((res, rej) => {
        resolveStoreId(tenantId, storeId, storeName).then((resolvedStoreId) => {
            const userDataKey = "User_Data";
            const userDataValue = `user_${tenantId}_${resolvedStoreId}`;

            if (!readLocalStorage(userDataKey)) {
                writeLocalStorage(userDataKey, userDataValue);
            }
            APISERVICE.GET(`${process.env.NEXT_PUBLIC_BASE_PCS_URL}/printBillDetails?storeId=${resolvedStoreId}&tenantId=${tenantId}`)
                .then((response) => {
                    // console.log("response?.data?.data", response?.data?.data)
                    res(response?.data);
                }).catch(function (error) {
                    console.error(error)
                    rej(error);
                });
        }).catch(function (error) {
            console.error(error)
            rej(error);
        });
    })
}

export const getLanguageKeywords = (tenantId: any, storeId: any, langCode: string = 'en') => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_BASE_PCS_URL}/langKeywords?tenantId=${tenantId}&storeId=${storeId}&langCode=${langCode}`)
            .then((response) => {
                res(response?.data);
            }).catch(function (error) {
                console.error(error)
                rej(error);
            });
    })
}


